/**
 * DigestReadOnlyFooter
 *
 * Rendered in place of ChatInput when the active session is a system-generated
 * Weekly Digest. Digest sessions are read-only — users cannot send messages
 * into them.
 */
export default function DigestReadOnlyFooter() {
	return (
		<div
			className="digest-readonly-footer"
			data-testid="digest-readonly-footer"
		>
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				aria-hidden="true"
				className="digest-readonly-footer__icon"
			>
				<rect x="1" y="10" width="2" height="5" rx="0.5" fill="currentColor" />
				<rect x="5" y="7" width="2" height="8" rx="0.5" fill="currentColor" />
				<rect x="9" y="4" width="2" height="11" rx="0.5" fill="currentColor" />
				<rect x="13" y="1" width="2" height="14" rx="0.5" fill="currentColor" />
			</svg>
			<span>This digest is read-only.</span>
		</div>
	);
}
